/* eslint-disable eol-last */
require('dotenv').config()
class Configs {
  /**
   *
   * @param {String} name : variable name
   * @return {String}
   */
  static GetEnvironmentVariable (name) {
    return process.env[name]
  }
}
module.exports = Configs
